/**
 * useTodoMeta Hook
 * Custom hook for managing todo meta/analytics
 */

import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { getTodoMeta, getTaskStats } from '@/services/finTasksService';

export function useTodoMeta() {
  const { user } = useAuth();
  const [meta, setMeta] = useState(null);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMeta = useCallback(async () => {
    if (!user?.uid) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const [metaData, statsData] = await Promise.all([
        getTodoMeta(user.uid),
        getTaskStats(user.uid)
      ]);
      
      setMeta(metaData);
      setStats(statsData);
    } catch (err) {
      console.error('Error fetching todo meta:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [user?.uid]);

  useEffect(() => {
    fetchMeta();
  }, [fetchMeta]);

  return {
    meta,
    stats,
    loading,
    error,
    refetch: fetchMeta
  };
}

export default useTodoMeta;
